import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import { Link } from '@printdeal/ui-library';
import { FormattedMessage } from 'react-intl';
import { SanitizedLineItem, SanitizedOrder } from '../../../../../../types/order/Order';
import { dispatchAccountEvent } from '../../../../../../helpers/dataLayerHelpers/accountDataLayerHelper';

interface AddComplaintButtonProps {
  lineItem: SanitizedLineItem,
  order: SanitizedOrder,
}

const AddComplaintButton = ({ lineItem, order }: AddComplaintButtonProps) => (
  <Link
    as={GatsbyLink}
    variant="secondary"
    to={`../../complaints/add/${order.id}/${lineItem.id}`}
    onClick={() => dispatchAccountEvent('order_detail_interaction', 'open_create_complaint')}
    iconBefore="chat"
    className="pd-text-xs"
  >
    <FormattedMessage
      id="widget.myaccount.sumbitComplaint"
      defaultMessage="Submit Complaint"
    />
  </Link>
);

export default AddComplaintButton;
